import React from "react";
import { Check, Plus } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

export function PricePlanCard({ module, plan, onChoose, payrollOn, togglePayroll }) {
  const { t } = useI18n();
  const addon = plan.payroll || plan.takeoff;
  const construction = !!module.construction;
  const addonConstruction = construction || !!(addon && addon.construction);
  const btnLabel = { starter: t("plancard.chooseStarter"), pro: t("plancard.choosePro"), enterprise: t("plancard.chooseEnterprise") };
  return (
    <div
      data-testid={`price-card-${module.key}-${plan.tier}`}
      className={`relative flex flex-col rounded-2xl border p-6 bg-[#0a0a0a] transition-colors ${
        plan.popular ? "border-[#EAB308]/50" : "border-white/10 hover:border-white/20"
      }`}
    >
      {plan.popular && (
        <span className="absolute -top-3 left-6 rounded-full bg-[#EAB308] px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-black">
          {t("plancard.popular")}
        </span>
      )}
      <h4 className="text-lg font-bold text-white">{plan.label}</h4>
      <div className="mt-3">
        <span className="text-3xl font-extrabold text-white tracking-tight">{plan.price} <span className="text-xl">$</span></span>
        <span className="text-sm text-white/45"> {t("plancard.perMonth")}</span>
      </div>

      <ul className="mt-5 space-y-2.5 flex-1">
        {plan.features.map((f) => (
          <li key={f} className="flex items-start gap-2.5 text-sm text-white/70">
            <Check className="w-4 h-4 mt-0.5 shrink-0 text-green-500" />
            {f}
          </li>
        ))}
      </ul>

      {addon && (
        <div className={`mt-5 rounded-xl border border-[#EAB308]/30 bg-[#EAB308]/[0.05] p-4 ${addonConstruction ? "relative opacity-60" : ""}`}>
          <div className="flex items-center justify-between gap-2">
            <div className="text-sm font-semibold text-[#EAB308]">{addon.name}</div>
            <div className="text-sm font-bold text-white">+{addon.price} $</div>
          </div>
          {addonConstruction && (
            <span
              data-testid={`addon-construction-badge-${module.key}-${plan.tier}`}
              className="mt-2 inline-flex items-center gap-1.5 rounded-full border border-[#f59e0b]/40 bg-[#f59e0b]/10 px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wider text-[#f5c77e]"
            >
              {t("plancard.constructionCta")}
            </span>
          )}
          <ul className="mt-2.5 space-y-1.5">
            {addon.features.map((f) => (
              <li key={f} className="flex items-start gap-2 text-xs text-white/60">
                <Check className="w-3.5 h-3.5 mt-0.5 shrink-0 text-[#EAB308]" />
                {f}
              </li>
            ))}
          </ul>
          <label className={`mt-3 flex items-center gap-2 ${addonConstruction ? "cursor-not-allowed" : "cursor-pointer"}`} data-testid={`addon-toggle-${module.key}-${plan.tier}`}>
            <input type="checkbox" checked={!addonConstruction && !!payrollOn} disabled={addonConstruction} onChange={togglePayroll} className="h-4 w-4 accent-[#EAB308] disabled:cursor-not-allowed" />
            <span className="text-xs text-white/80 flex items-center gap-1"><Plus className="w-3 h-3 text-[#EAB308]" /> {t("plancard.add")} {addon.name}</span>
          </label>
        </div>
      )}

      {construction ? (
        <button
          data-testid={`price-cta-${module.key}-${plan.tier}`}
          disabled
          className="mt-6 w-full rounded-lg h-11 font-semibold bg-white/5 border border-[#f59e0b]/40 text-[#f5c77e] cursor-not-allowed"
        >
          {t("plancard.constructionCta")}
        </button>
      ) : (
        <button
          data-testid={`price-cta-${module.key}-${plan.tier}`}
          onClick={() => onChoose(module, plan, !!payrollOn)}
          className="mt-6 w-full rounded-lg h-11 font-semibold bg-black border border-[#EAB308] text-[#EAB308] hover:bg-[#EAB308] hover:text-black transition-colors"
        >
          {btnLabel[plan.tier]}
        </button>
      )}
    </div>
  );
}
